// @ts-nocheck
import type { HeadstoneDTO } from "../api/client";
import { getCurrentUser } from "../auth/session";
import { navigateToHeadstone } from "../map/headstone-nav";
import {
  getHasHeadstones,
  getMyHeadstones,
  onPostsAccessChange,
} from "./posts-access";
import { dtoToLegacy } from "../utils/dto";
import { t } from "../i18n";

let lastVisitedHeadstoneId: string | null = null;

function sortedHeadstones(): HeadstoneDTO[] {
  return [...getMyHeadstones()].sort(
    (a, b) =>
      new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
  );
}

function pickNextHeadstone(): HeadstoneDTO | null {
  const list = sortedHeadstones();
  if (!list.length) return null;
  if (list.length === 1) return list[0];

  const candidates = lastVisitedHeadstoneId
    ? list.filter((h) => h.id !== lastVisitedHeadstoneId)
    : list;
  const pool = candidates.length ? candidates : list;
  return pool[0];
}

export function updateMyMemorialButtonLabels(headstone?: HeadstoneDTO | null): void {
  const btn = document.getElementById("my-memorial-btn");
  if (!btn) return;

  const list = sortedHeadstones();
  const total = list.length;
  const current = headstone ?? (lastVisitedHeadstoneId
    ? list.find((h) => h.id === lastVisitedHeadstoneId)
  : list[0]);

  let label = t("toolbar.myMemorial");
  if (current && total > 1) {
    const index = list.findIndex((h) => h.id === current.id) + 1;
    label = t("toolbar.myMemorialNext", { current: index, total });
  } else if (current) {
    label = t("toolbar.myMemorialNamed", { name: current.pet.name });
  }

  btn.title = label;
  btn.setAttribute("aria-label", label);
}

function syncMyMemorialButtonVisibility(): void {
  const btn = document.getElementById("my-memorial-btn");
  if (!btn) return;

  const visible = !!getCurrentUser() && getHasHeadstones();
  if (visible) {
    btn.removeAttribute("hidden");
    updateMyMemorialButtonLabels();
  } else {
    btn.setAttribute("hidden", "");
    lastVisitedHeadstoneId = null;
  }

  if (typeof lucide !== "undefined") lucide.createIcons();
}

export function goToMyMemorial(): void {
  if (!getCurrentUser()) {
    window.openAuthModal("login", t("auth.loginForTombs"));
    return;
  }

  const headstone = pickNextHeadstone();
  if (!headstone) return;

  lastVisitedHeadstoneId = headstone.id;
  navigateToHeadstone(dtoToLegacy(headstone));
  updateMyMemorialButtonLabels(headstone);
}

export function initGoToMyMemorial(): void {
  onPostsAccessChange(syncMyMemorialButtonVisibility);
  syncMyMemorialButtonVisibility();
}

export function resetMyMemorialCycle(): void {
  lastVisitedHeadstoneId = null;
  updateMyMemorialButtonLabels();
}

declare const lucide: any;
